"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


var _chunkQ4G2SZRDjs = require('./chunk-Q4G2SZRD.js');

// src/common-components/select/select.tsx
var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _b_ = require('b_'); var _b_2 = _interopRequireDefault(_b_);
var b = _b_2.default.with("select");
var Select = class extends _react2.default.Component {
  render() {
    const _a = this.props, { children, mix = "", size = "m" } = _a, rest = _chunkQ4G2SZRDjs.__objRest.call(void 0, _a, ["children", "mix", "size"]);
    const classes = `${b({ size })} ${mix}`;
    return /* @__PURE__ */ _react2.default.createElement("div", { className: classes }, /* @__PURE__ */ _react2.default.createElement("select", _chunkQ4G2SZRDjs.__spreadValues.call(void 0, {}, rest), children));
  }
};



exports.Select = Select;
//# sourceMappingURL=chunk-VEXLEQSE.js.map